import { Link } from "react-router-dom";
import { PHONE, PHONE_HREF, EMAIL, ADDRESS } from "@/lib/site";

export default function Footer() {
  return (
    <footer className="bg-ink text-bone relative grain" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <p className="font-display text-3xl font-bold tracking-tight">Breeze Craft</p>
          <p className="mt-3 text-sm text-bone/60 max-w-sm leading-relaxed">
            Sydney-wide breeze block supply and master installation. Feature walls, pool screens, front fences and commercial facades.
          </p>
          <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.25em] text-bone/40">
            Lic. NSW 347441C · Fully insured · Est. 2006
          </p>
        </div>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-bone/40 mb-4">Explore</p>
          <div className="flex flex-col gap-2 text-sm">
            <Link to="/catalogue" data-testid="footer-link-catalogue" className="text-bone/70 hover:text-terracotta transition-colors">Block Catalogue</Link>
            <Link to="/services" data-testid="footer-link-services" className="text-bone/70 hover:text-terracotta transition-colors">Services</Link>
            <Link to="/areas" data-testid="footer-link-areas" className="text-bone/70 hover:text-terracotta transition-colors">Service Areas</Link>
            <Link to="/quote" data-testid="footer-link-quote" className="text-bone/70 hover:text-terracotta transition-colors">Get a Quote</Link>
          </div>
        </div>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-bone/40 mb-4">Contact</p>
          <div className="flex flex-col gap-2 text-sm text-bone/70">
            <a href={PHONE_HREF} data-testid="footer-phone-link" className="hover:text-terracotta transition-colors">{PHONE}</a>
            <a href={`mailto:${EMAIL}`} data-testid="footer-email-link" className="hover:text-terracotta transition-colors">{EMAIL}</a>
            <p>Mon–Fri 7am–5pm · Sat by appointment</p>
            <p data-testid="footer-address">{ADDRESS}</p>
          </div>
        </div>
      </div>
      <div className="border-t border-bone/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 pt-5 text-[11px] leading-relaxed text-bone/40 max-w-3xl" data-testid="footer-disclaimer">
          Breeze Craft is an independent breeze block supplier and installer. We are not affiliated with, authorised by, or endorsed by Austral Masonry or any other manufacturer named on this site. Brand names belong to their respective owners.
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-5 flex flex-col sm:flex-row justify-between gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-bone/30">
          <span>© {new Date().getFullYear()} Breeze Craft</span>
          <span>Built for Sydney blocks</span>
        </div>
      </div>
    </footer>
  );
}
